import { render, staticRenderFns } from "./updatestaffModel.vue?vue&type=template&id=58069282&scoped=true"
import script from "./updatestaffModel.vue?vue&type=script&lang=js"
export * from "./updatestaffModel.vue?vue&type=script&lang=js"
import style0 from "./updatestaffModel.vue?vue&type=style&index=0&id=58069282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58069282",
  null
  
)

export default component.exports